import { render, staticRenderFns } from "./bonuses.vue?vue&type=template&id=1c1fc5c3&"
import script from "./bonuses.vue?vue&type=script&lang=js&"
export * from "./bonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bonuses.vue"
export default component.exports